// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-iam-access-dialog-add-user-action-panel {
  display: flex;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--g-color-line-generic);
}
.dl-iam-access-dialog-add-user-action-panel__info {
  flex: 1;
}
.dl-iam-access-dialog-add-user-action-panel__change-role {
  margin-left: 6px;
  min-width: 170px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/IamAccessDialog/AddSubjects/ActionPanel/ActionPanel.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,oDAAA;AACJ;AACI;EACI,OAAA;AACR;AAEI;EACI,gBAAA;EACA,gBAAA;AAAR","sourcesContent":[".dl-iam-access-dialog-add-user-action-panel {\n  display: flex;\n  align-items: center;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--g-color-line-generic);\n}\n.dl-iam-access-dialog-add-user-action-panel__info {\n  flex: 1;\n}\n.dl-iam-access-dialog-add-user-action-panel__change-role {\n  margin-left: 6px;\n  min-width: 170px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
